import { BlockInstance, createBlock } from "@wordpress/blocks";
import { dispatch, select, subscribe } from "@wordpress/data";
import * as actions from "wordpress__block-editor/store/actions";

const subscribeOnceWhen = (predicate: () => boolean, callback: () => void) => {
	const unsubscribe = subscribe(() => {
		if (predicate()) {
			setTimeout(() => {
				callback();
			}, 500);
			unsubscribe();
		}
	});

	return unsubscribe;
};

const isBlocksLoaded = () => {
	const { getBlocks } = select("core/block-editor");
	return getBlocks().length > 0;
};

const recoverBlock = ({
	name,
	attributes,
	innerBlocks,
}: {
	name: string;
	attributes: {
		[key: string]: any;
	};
	innerBlocks: any;
}) => createBlock(name, attributes, innerBlocks);

const getInvalidBlocks = (blocks: BlockInstance[]) => {
	return blocks.reduce((invalidBlocks, block) => {
		if (!block.isValid && block.name.includes("magazine-blocks")) {
			invalidBlocks.push(block as never);
		}
		if (block.innerBlocks.length > 0) {
			const invalidInnerBlocks = getInvalidBlocks(block.innerBlocks);
			if (invalidInnerBlocks.length > 0) {
				invalidBlocks = invalidBlocks.concat(invalidInnerBlocks);
			}
		}
		return invalidBlocks;
	}, []);
};

const recoverBlocks = () => {
	const { replaceBlock } = dispatch("core/block-editor") as typeof actions;
	let blocks;

	if (
		"widgets" === (window as any).pagenow ||
		"customize" === (window as any).pagenow
	) {
		const widgetAreas = select("core/block-editor").getBlocks();
		blocks = widgetAreas.map((widgetArea: BlockInstance) => {
			const innerBlocks = select("core/block-editor").getBlocks(
				widgetArea.clientId
			);
			return {
				...widgetArea,
				innerBlocks,
			};
		});
	} else {
		blocks = select("core/block-editor").getBlocks();
	}

	if (blocks?.length) {
		const invalidBlocks = getInvalidBlocks(blocks);

		if (invalidBlocks?.length) {
			invalidBlocks.forEach((oldBlock: BlockInstance) => {
				const newBlock = recoverBlock(oldBlock);

				if (newBlock.isValid) {
					replaceBlock(oldBlock.clientId, newBlock);
				}
			});
		}
	}
};

const autoRecoverBlocks = () => {
	return new Promise<void>((resolve) => {
		subscribeOnceWhen(isBlocksLoaded, () => {
			recoverBlocks();
			setTimeout(() => resolve(), 200);
		});
	});
};

export default autoRecoverBlocks;
